var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVuejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -17.5 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.8 0H256L128 220.8 0 0h97.92L128 51.2 157.44 0h47.36z",
    fill: "#41B883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l128 220.8L256 0h-51.2L128 132.48 50.56 0H0z",
    fill: "#41B883"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.56 0L128 133.12 204.8 0h-47.36L128 51.2 97.92 0H50.56z",
    fill: "#35495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuejs);
export default __webpack_public_path__ + "static/media/vuejs.0c97e313d781a6b074e5fdb359cc83f6.svg";
export { ForwardRef as ReactComponent };